import { createClient } from '@supabase/supabase-js'

// Placeholder URL and Key - User must replace these
const supabaseUrl = 'https://fzkptteqaooavawzwwlu.supabase.co'
const supabaseKey = 'sb_publishable_dM1qkI8do32UFg0DbXK9eA__jba03k-'

export const supabase = createClient(supabaseUrl, supabaseKey)

export type HuaweiOrder = {
  Site_ID_NE: string
  Site_Name_NE: string
  Area: string
  TREG: string
  Regional_Tsel: string
  Tipe_Site: string
  Kapasitas: number
  Frekuensi: string
  Freq_Grouping: string
  Status_Redeploy: string
  Status_Material: string
  Status_koneksi_NMS: string
  Status_Potensi_redeploy: string
  ODU_NE: number
  ODU_FE: number
  IDU: number
  Antenna: number
  Modem: number
  Program: string
}
